import { PaymentMethodsEnum } from '../../../../../views/phone-answering/constants';

export default {
  options: {
    [PaymentMethodsEnum.Cash]: 'Cash',
    [PaymentMethodsEnum.Online]: 'Online',
    [PaymentMethodsEnum.InStoreCard]: 'In store card',
  },
};
